import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import '../../stylings/NormalNotice.css';

export default function NormalNotice() {
  const notices = useSelector((state) => state.notices.notices);
  const general = notices.filter((n) => n.noticeType !== 'ADMISSION' && n.type !== 'admission');

  const fallback = [
    { _id: 'n1', title: 'Annual Sports Day – 15 June 2025', date: '2025-05-20' },
    { _id: 'n2', title: 'Parent-Teacher Meeting scheduled for July 20, 2025', date: '2025-05-18' },
    { _id: 'n3', title: 'Summer Vacation from May 25 to June 29, 2025', date: '2025-05-15' },
    { _id: 'n4', title: 'Science Exhibition – July 5, 2025', date: '2025-05-12' },
  ];

  const items = general.length > 0 ? general : fallback;

  return (
    <div className="notice-widget">
      <div className="notice-widget-header general-header">
        <i className="fas fa-bell me-2"></i> Important Notices
      </div>
      <div className="notice-widget-body">
        <ul className="notice-list">
          {items.slice(0, 6).map((n) => (
            <li key={n._id} className="notice-list-item">
              <Link to={`/notice/${n._id}`} className="notice-link">
                <span className="notice-dot general-dot"></span>
                <div className="notice-text">
                  <p className="notice-title">{n.title}</p>
                  <span className="notice-date">
                    <i className="fas fa-calendar-check me-1"></i>
                    {moment(n.date || n.createdAt).format('DD MMM YYYY')}
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="notice-widget-footer">
        <Link to="/noticeall">View All Notices →</Link>
      </div>
    </div>
  );
}
